
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kBJIb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "CommentReplies", () => $f219a906c7f9e73b$export$c38311e545a763a);
$parcel$export(module.exports, "default", () => $f219a906c7f9e73b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGvGJ = parcelRequire("dGvGJ");

var $8Rkzz = parcelRequire("8Rkzz");

var $kVVL1 = parcelRequire("kVVL1");

var $d4MOh = parcelRequire("d4MOh");

var $9pF5v = parcelRequire("9pF5v");

var $fKtck = parcelRequire("fKtck");

var $8zOmE = parcelRequire("8zOmE");

var $8dFNe = parcelRequire("8dFNe");

var $1XJ20 = parcelRequire("1XJ20");

var $g2C8o = parcelRequire("g2C8o");

var $18jBk = parcelRequire("18jBk");

var $iNUY0 = parcelRequire("iNUY0");

var $aMt4H = parcelRequire("aMt4H");
const $f219a906c7f9e73b$var$memoizedReplies = (0, $dGvGJ.createSelector)((commentId, state)=>(0, $d4MOh.commentRepliesSelector)(commentId)(state), (result)=>result);
const $f219a906c7f9e73b$var$memoizedPagesInfo = (0, $dGvGJ.createSelector)((commentId, state)=>(0, $d4MOh.childCommentsPageInfoSelector)(commentId)(state), (result)=>result);
const $f219a906c7f9e73b$var$memoizedReplyEditor = (0, $dGvGJ.createSelector)((commentId, state)=>(0, $d4MOh.isReplyingToCommentSelector)(commentId)(state), (result)=>result);
const $f219a906c7f9e73b$export$c38311e545a763a = (props)=>{
    const { fullIssueUrl: fullIssueUrl, commentSessionId: commentSessionId, commentId: commentId } = props;
    const dispatch = (0, $kVVL1.useDispatch)();
    const isReplyingToComment = (0, $kVVL1.useSelector)((state)=>$f219a906c7f9e73b$var$memoizedReplyEditor(commentId, state));
    const replies = (0, $kVVL1.useSelector)((state)=>$f219a906c7f9e73b$var$memoizedReplies(commentId, state));
    const childCommentsPageInfo = (0, $kVVL1.useSelector)((state)=>$f219a906c7f9e73b$var$memoizedPagesInfo(commentId, state));
    const loadingStage = (0, $kVVL1.useSelector)((state)=>(0, $d4MOh.loadingStageSelector)(state));
    const getMoreOlderComments = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $8dFNe.fetchOlderChildCommentsRequest)(commentId));
    }, [
        dispatch,
        commentId
    ]);
    const getMoreNewerComments = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $8dFNe.fetchNewerChildCommentsRequest)(commentId));
    }, [
        dispatch,
        commentId
    ]);
    const previousRepliesLength = (0, $1XJ20.usePrevious)(replies?.length);
    (0, $5uXOq.useEffect)(()=>{
        if (childCommentsPageInfo) {
            const repliesLength = replies?.length;
            if (previousRepliesLength !== repliesLength && (!replies || repliesLength === 0)) {
                if (childCommentsPageInfo.hasNextPage) getMoreOlderComments();
                else if (childCommentsPageInfo.hasPreviousPage) getMoreNewerComments();
            }
        }
    }, [
        replies,
        childCommentsPageInfo,
        previousRepliesLength,
        getMoreNewerComments,
        getMoreOlderComments
    ]);
    if (!replies || replies.length === 0) return null;
    const { hasPermalink: hasPermalink, permalinkId: permalinkId } = (0, $fKtck.getPermalinkStatus)((0, $9pF5v.COMMENTS));
    const showOlderComments = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'showMoreReplies', {
            olderComments: true
        });
        getMoreOlderComments();
    };
    const showNewerComments = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'showMoreReplies', {
            newerComments: true
        });
        getMoreNewerComments();
    };
    const hasReplies = replies && replies.length > 0;
    const isNewChildCommentSaving = loadingStage === `${0, $g2C8o.SAVE_CHILD_COMMENT_LOADING_PREFIX}${commentId}`;
    const isLatestChildCommentNotVisible = childCommentsPageInfo?.hasPreviousPage;
    if (isNewChildCommentSaving && isLatestChildCommentNotVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMt4H.default), {
        onClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        commentId: commentId,
        type: (0, $g2C8o.ActionButton).PREVIOUS,
        forceShowLoadingState: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, childCommentsPageInfo?.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMt4H.default), {
        onClickHandler: showOlderComments,
        commentId: commentId,
        type: (0, $g2C8o.ActionButton).PREVIOUS
    }), hasReplies && replies.map((childCommentId, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNUY0.default), {
            key: childCommentId,
            isFirst: index === 0 && !childCommentsPageInfo?.hasNextPage,
            isLast: index === replies.length - 1 && !isReplyingToComment && !childCommentsPageInfo?.hasPreviousPage,
            addMargin: index !== replies.length - 1 || isReplyingToComment && !childCommentsPageInfo?.hasPreviousPage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $18jBk.default), {
            commentId: childCommentId,
            fullIssueUrl: fullIssueUrl,
            isHighlighted: hasPermalink && childCommentId === permalinkId,
            commentSessionId: commentSessionId,
            isThreadedCommentsEnabled: true
        }))), childCommentsPageInfo?.hasPreviousPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMt4H.default), {
        onClickHandler: showNewerComments,
        commentId: commentId,
        type: (0, $g2C8o.ActionButton).NEXT,
        isReplyingToComment: isReplyingToComment
    }));
};
var $f219a906c7f9e73b$export$2e2bcd8739ae039 = $f219a906c7f9e73b$export$c38311e545a763a;

});
parcelRegister("aMt4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdf1643c7b2eaf65$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gPt5r = parcelRequire("gPt5r");
var $85183 = parcelRequire("85183");
var $gDPDy = parcelRequire("gDPDy");

var $47t9U = parcelRequire("47t9U");

var $iTaot = parcelRequire("iTaot");

var $hxqfC = parcelRequire("hxqfC");

var $g2C8o = parcelRequire("g2C8o");

var $d4MOh = parcelRequire("d4MOh");

var $koVbs = parcelRequire("koVbs");

var $iNUY0 = parcelRequire("iNUY0");

var $7awT9 = parcelRequire("7awT9");
const $bdf1643c7b2eaf65$var$ShowMoreContainer = ({ onClickHandler: onClickHandler, activeLoadingButton: activeLoadingButton, type: type, forceShowLoadingState: forceShowLoadingState, isReplyingToComment: isReplyingToComment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iNUY0.default), {
        showNextButton: type === (0, $g2C8o.ActionButton).NEXT,
        isLast: !isReplyingToComment && type === (0, $g2C8o.ActionButton).NEXT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85183.default), {
        alignBlock: "center",
        xcss: $bdf1643c7b2eaf65$var$containerStyles,
        testId: "issue-view-activity-comment.comment-show-more-replies.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testId": "issue-view-activity-comment.comment-show-more-replies.empty-container",
        className: (0, $bwpsq.default)([
            "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _p12f1kdh _kqswh2mm _uglpt94y _161e1v33 _1pty1eak _2knc163p _qlwi163p _631ousvi _aetrb3bt _18postnw _g0nf1yie _15l24uri _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
        xcss: $bdf1643c7b2eaf65$var$buttonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47t9U.default), {
        onClick: (e, analyticsEvent)=>onClickHandler(analyticsEvent),
        appearance: "subtle",
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($iTaot))),
        isLoading: activeLoadingButton === type || forceShowLoadingState,
        testId: "issue-view-activity-comment.comment-show-more-replies.show-more-button"
    }, formatMessage((0, $7awT9.messages).showMoreRepliesText)))));
};
const $bdf1643c7b2eaf65$var$containerStyles = (0, $gDPDy.xcss)({
    position: 'relative'
});
const $bdf1643c7b2eaf65$var$buttonContainer = (0, $gDPDy.xcss)({
    position: 'absolute'
});
const $bdf1643c7b2eaf65$var$emptyContainerStyles = null;
var $bdf1643c7b2eaf65$export$2e2bcd8739ae039 = (0, $hxqfC.connect)((state, ownProps)=>({
        activeLoadingButton: (0, $d4MOh.loadingMoreChildCommentsSelector)(ownProps.commentId)(state)
    }))($bdf1643c7b2eaf65$var$ShowMoreContainer);

});
parcelRegister("7awT9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2f976e21e5feccb0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2f976e21e5feccb0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    showMoreRepliesText: {
        "id": "issue-view-activity-comment.comment-replies.show-more-replies",
        "defaultMessage": "Show more replies"
    }
});

});




//# sourceMappingURL=async-reply-comments-list.b2500f07.js.map
